<template>
  <b-sidebar
    id="sidebar-update-student"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Update student') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="studentUpdate">

          <!-- Period -->
          <b-form-group
            :label="$t('Course')"
            label-for="student"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Course')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="student.course"
                :options="[1,2,3]"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            :label="$t('PNFL')"
            label-for="searchAdvisor"
          >
            <b-form-input
              id="searchAdvisor"
              v-model="student.pnfl"
            />
          </b-form-group>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Update') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    student() {
      return this.$store.state[this.MODULE_NAME].student
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.$refs.studentUpdate.reset()
      hide()
    },
    submit(hide) {
      this.$refs.studentUpdate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.student, `${this.MODULE_NAME}/orgUpdateApplyDoc`, () => {
            this.$emit('refetchData')
            this.clear(hide)
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'student'
    return {
      MODULE_NAME,
    }
  },
}
</script>
